import { PersistableAction } from "../actions/base-actions";
import { IStorageKey } from "../../interfaces/interfaces";
import { isBaseObject } from "../../util/utils";

export class StateHelper {

    static makeKey(action: PersistableAction): string {

        try {
            return action.getKey();
        } catch (e) {
            return undefined;
        }
    }

    static getType(action: PersistableAction): string {

        const keyParsed = StateHelper.parseStorageKey(action.getKey());

        return keyParsed.keyType;
    }

    /**
     * @param {string} key
     * @returns {IStorageKey}
     */
    static parseStorageKey(key: string): IStorageKey {
        const parts = key.split(":");
        return {
            entity: parts[0],
            keyType: parts[1],
            id: parts[2]
        };
    }

    static preparePayload(action: PersistableAction): any {

        const type = StateHelper.getType(action);

        if (type === "selected" && isBaseObject(action.payload)) {
            return action.payload.id;
        }

        return action.payload;

    }

    /**
     * Return true if the action is a remove
     * @param action
     * @returns {StateHelper}
     */
    static isRemoveAction(action: PersistableAction): boolean {
        return !!action.type.match(/Remove$/);
    }

    /**
     * Return true if the action is a submit
     * @param action
     * @returns {StateHelper}
     */
    static isSubmitAction(action: PersistableAction): boolean {
        return !!action.type.match(/Submit$/);
    }
}



// WEBPACK FOOTER //
// ./src/core/store/helpers/statehelper.ts